var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pdf-item"},[_c('h1'),_c('img',{attrs:{"src":require("../assets/grafico1.png"),"width":"900"}})])}]

export { render, staticRenderFns }